import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const saleCommissionPdf = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();
    const userName = store.state.user.user.name;

    const exportToPDF = (company, personalSaleCommission, groupSaleCommissionData, companySaleShareData, totalValue, month) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(personalSaleCommission, groupSaleCommissionData, companySaleShareData, totalValue, month),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Commission -' + formatYearMonth(month),
            }
        }

        pushIntoTable(doc, personalSaleCommission, groupSaleCommissionData, totalValue)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function formatYearMonth(value) {
        if (!value) return '';
        const [year, month] = value.split('-');
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' })
            .format(new Date(year, month - 1));
    }

    const getContent = (personalSaleCommission, groupSaleCommissionData, companySaleShareData, totalValue, month) => {
        return [
            {
                text:  'Sale Commission -' + formatYearMonth(month),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                columns: [
                    {
                        width: '50%',
                        table: {
                            body: totalSummaryData(totalValue),
                            widths: ['60%', '40%']
                        },
                        layout: {
                            fillColor: function (rowIndex) {
                                return (rowIndex === 0) ? '#f3f2f7' : null;
                            },
                            hLineWidth: function () { return 0.5; },
                            vLineWidth: function () { return 0.5; }
                        },
                        margin: [0, 10, 0, 0]
                    },
                    { width: '*', text: '' }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '5%', '10%', '10%', '5%', '10%', '10%', '10%', '10%', '10%', '10%', '10%'  ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },

            ...(Number(totalValue.total_company_sale_share) > 0 ? [{
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: companySaleShareDta(companySaleShareData, totalValue),
                    widths: ['10%', '15%', '15%', '15%', '15%', '15%', '15%']
                },
                layout: {
                    fillColor: function (rowIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
                }
            }] : []),
        ]
    }

    function totalSummaryData(totalValue) {
        const rows = [
            [
                { text: 'Particulars' },
                { text: 'Amount', alignment: 'right' },
            ]
        ];

        const addRow = (label, value, bold = false) => {
            if (value !== undefined && value !== null && Number(value) !== 0) {
                rows.push([
                    { text: label, bold: bold },
                    { text: commaFormat(value), alignment: 'right' },
                ]);
            }
        };

        addRow('Personal Sales Commission', totalValue.personal_sales_commission);
        addRow('Group Sales Commission', totalValue.total_group_commission_amount);
        addRow('Company Sales Share', totalValue.total_company_sale_share);
        addRow('BP Commission', totalValue.total_group_bp_commission_amount);
        addRow('Total Commission', totalValue.total_commission, true);

        return rows;
    }

    function companySaleShareDta(companySaleShareData, totalValue) {
        let dataRow = [
            [
                { text: 'Level Qualified'},
                { text: 'Equivalent Designation'},
                { text: 'Company Sales Share %', alignment: 'right' },
                { text: 'Total Company Sales', alignment: 'right' },
                { text: 'Total Company Sales Share', alignment: 'right' },
                { text: 'Total Qualified Team This month', alignment: 'right' },
                { text: 'Company Sales Share Amount', alignment: 'right' },
            ]
        ];

        dataRow.push([
            { text: 'C. COMPANY SALE SHARE', colSpan: 7, bold: true, alignment: 'left' },
            {}, {}, {}, {}, {}, {}
        ]);

        companySaleShareData.forEach(item => {
            dataRow.push([
                {text: item.level_name},
                {text: item.equivalent_designation},
                {text: item.company_sale_share_percentage + '%', alignment: 'right'},
                {text: commaFormat(item.total_company_sales), alignment: 'right'},
                {text: commaFormat(item.total_company_sale_share), alignment: 'right'},
                {text: item.total_qualified_member, alignment: 'right'},
                {text: commaFormat(item.distributed_company_share_amount), alignment: 'right'},
            ]);
        });

        dataRow.push([
            {text: 'Total', colSpan: 5, alignment: 'center', bold: true}, {}, {}, {}, {},
            {text: totalValue.total_qualified_member, alignment: 'right', bold: true},
            {text: commaFormat(totalValue.total_company_sale_share), alignment: 'right', bold: true}
        ]);

        return dataRow;
    }

    const pushIntoTable = (doc, personalSaleCommission, groupSaleCommissionData, totalValue) => {
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);
        let rows = getCommissionTable(personalSaleCommission, groupSaleCommissionData, totalValue);
        doc.content[2].table.body.push(...rows);
    }

    const getCommissionTable = (personalSaleCommission, groupSaleCommissionData, totalValue) => {
        const body = [];

        if (Number(totalValue.personal_sales_commission) > 0) {
            body.push([
                {text: 'A. PERSONAL SALES COMMISSION', colSpan: 11, bold: true, alignment: 'left'},
                {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
            ]);

            body.push([
                {text: personalSaleCommission.serial_no},
                {text: personalSaleCommission.name},
                {text: `${personalSaleCommission.level_name} (${personalSaleCommission.equivalent_designation})`},
                {text: personalSaleCommission.parent_serial_no, alignment: 'right'},
                {text: commaFormat(personalSaleCommission.allocated_sales_amount), alignment: 'right'},
                {text: `${personalSaleCommission.monthly_level_name} (${personalSaleCommission.monthly_equivalent_designation})`},
                {text: commaFormat(personalSaleCommission.sales_commission_percentage), alignment: 'right'},
                {text: commaFormat(personalSaleCommission.sales_commission_amount), alignment: 'right'},
                {text: 'Not Applicable for Personal sales', colSpan: 3, alignment: 'center'},
                {}, {}
            ]);
        }

        if (Number(totalValue.total_group_commission_amount) > 0 || Number(totalValue.total_group_bp_commission_amount) > 0) {
            body.push([
                {text: 'B. GROUP SALES COMMISSION', colSpan: 11, bold: true, alignment: 'left'},
                {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
            ]);

            groupSaleCommissionData.forEach(item => {
                body.push([
                    {text: item.serial_no},
                    {text: item.name},
                    {text: `${item.level_name} (${item.equivalent_designation})`},
                    {text: item.parent_serial_no},
                    {text: commaFormat(item.allocated_sales_amount), alignment: 'right'},
                    {text: `${item.monthly_level_name} (${item.monthly_equivalent_designation}) (${item.monthly_qualified})`},
                    {text: `${item.group_sale_percentage}%`, alignment: 'right'},
                    {text: commaFormat(item.group_commission_amount), alignment: 'right'},
                    {text: item.generation, alignment: 'right'},
                    {text: `${item.bp_commission_percentage}%`, alignment: 'right'},
                    {text: commaFormat(item.bp_commission_amount), alignment: 'right'},
                ]);
            });

            body.push([
                {text: 'Total', colSpan: 4, alignment: 'center', bold: true}, {}, {}, {},
                {text: commaFormat(totalValue.total_group_allocated_sales_amount), alignment: 'right', bold: true},
                {text: '', alignment: 'center'},
                {text: '', alignment: 'center'},
                {text: commaFormat(totalValue.total_group_commission_amount), alignment: 'right', bold: true},
                {text: '', alignment: 'center'},
                {text: '', alignment: 'center'},
                {text: commaFormat(totalValue.total_group_bp_commission_amount), alignment: 'right', bold: true}
            ]);
        }

        return body;
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: 'Staff ID'},
            {text: 'Staff Name'},
            {text: 'Designation'},
            {text: 'Ref ID'},
            {text: 'Allocated Sales Amount', alignment: 'right'},
            {text: 'Qualified Rank'},
            {text: 'Com %', alignment: 'right'},
            {text: 'Sales Commission', alignment: 'right'},
            {text: 'Generation', alignment: 'right'},
            {text: 'BP Com %', alignment: 'right'},
            {text: 'BP Commission Amount', alignment: 'right'},
        ]

        return tableHeader
    }

    return {
        exportToPDF
    }
}

export default saleCommissionPdf;